import { useEffect, useState } from "react";

import useAuth from "@/contexts/auth-context";
import useDownloadMedia from "@/hooks/requests/message/use-download-media";
import useGetMediaById from "@/hooks/requests/message/use-get-midia-by-id";

const useChatBalloonData = (midiaIdFormat: number) => {
  const [mediaLoaded, setMediaLoaded] = useState(false);
  const { user } = useAuth();

  const { data: media, isLoading: isMediaDetailsLoading } = useGetMediaById({
    _id: midiaIdFormat || 0,
  });

  const { mediaURL, isLoading: isMediaLoading } = useDownloadMedia({
    _id: midiaIdFormat,
    _media: media,
  });

  useEffect(() => {
    if (media) {
      setMediaLoaded(true);
    }
  }, [media]);

  const handleMediaLoaded = () => {
    setMediaLoaded(true);
  };
  return {
    user,
    media,
    mediaURL,
    mediaLoaded,
    handleMediaLoaded,
    isLoading: isMediaDetailsLoading || isMediaLoading,
  };
};

export default useChatBalloonData;
